import { render, staticRenderFns } from "./SingleProvider.vue?vue&type=template&id=106f7b60&"
import script from "./SingleProvider.vue?vue&type=script&lang=js&"
export * from "./SingleProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports